// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605140903/js/" + chunkId + "." + {"44":"b73c35c4","225":"1edc68b4","481":"f6cdc0b9","486":"a4805a43","770":"dbe596d9"}[chunkId] + ".0.140396456972409.chunk.js";
};